import { get, post } from 'api/request'

export const API_PROJECT = "/project/service/project"

export const getProjectList = (key) => get(`${API_PROJECT}/?goal=service`)
export const getProjectDetail = (key) => get(`${API_PROJECT}/${key}`)
